<template lang="pug">
    article#noticia
        Banner(:imagem="noticia.topo_link")
        Conteudo(:noticia="noticia")
        Listagem(:listagem="listagem")
</template>

<script>
import Banner from '@sections/Noticia/Banner/Banner.vue'
import Conteudo from '@sections/Noticia/Conteudo/Conteudo.vue'
import Listagem from '@sections/Noticia/Listagem/Listagem.vue'

export default {
    name: "view-noticia",
    components: {
        Banner,
        Conteudo,
        Listagem
    },
    data() {
        return {
            listagem: {},
            noticia: {}
        }
    },
    created() {
        this.loadNoticia(this.$route.params.slug)
    },
    beforeRouteUpdate(to, from, next) {
        if(to.name == 'noticia' && to.params.slug != this.noticia.slug){
            this.loadNoticia(to.params.slug)
        }
        next()
    },
    methods: {
        loadNoticias(slug = '') {
            this.$axios
                .get(`noticias/${slug}/destaques?limit=3`)
                .then(response => {
                    this.listagem = Object.assign({}, response.data)
                })
                .catch(() => {
                    this.listagem = {}
                })
        },
        loadNoticia(slug = ''){
            this.$axios
                .get(`noticias/${slug}`)
                .then(response => {
                    this.noticia = Object.assign({}, response.data)
                }).then(() => {
                    this.loadNoticias(slug)
                })
        }
    },
}
</script>

<style lang="stylus" scoped src="./Noticia.styl"></style>